import { useEffect } from "react";
import { useLocation } from "react-router";

export const StripeScriptLoader: React.FunctionComponent = () => {
	const location = useLocation();

	useEffect(() => {
		let script: HTMLScriptElement | null = null;
		if (location.pathname.includes("/payment-setup") || location.pathname.includes("/billing")) {
			script = document.createElement("script");
			script.type = 'application/javascript';
			script.src = '/api/stripe.js';
			script.async = true;

			document.body.appendChild(script);
		}

		return () => {
			if (script) {
				document.body.removeChild(script);
			}
		};
	}, [location]);

	return null;
}